import { Column } from "primereact/column";
import { useFormsEditStore } from "presentation/stores/use-forms-edit.store";
import { Button } from "primereact/button";
import { DataTable, DataTableValueArray } from "primereact/datatable";
import { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import ManageQuestion from "../ManageQuestion";
import { FormQuestion } from "domain/entities/form-question";
import {
  ConfirmDialog,
  confirmDialog,
} from "primereact/confirmdialog";

const ManageQuestionsGrid = () => {
    const state = useFormsEditStore();

    const dt = useRef<DataTable<DataTableValueArray>>(null);

    const [editQuestionVisible, setEditQuestionsVisible] = useState<boolean>(false);
    const [currentQuestionId, setCurrentQuestionId] = useState<string | null>(null);

    const deleteQuestion = (questionId:string) => {

        const currentState = useFormsEditStore.getState().formData; 
        const questions = currentState.questions.filter((question) => question.id !== questionId);
        
        if(currentState.addedQuestions.includes(questionId)){
            const addedQuestionsWithoutOne = currentState.addedQuestions.filter((question) => question !== questionId);

            state.setFormsEdit({
                ...currentState,
                questions: questions,
                addedQuestions: addedQuestionsWithoutOne,
                totalQuestions: currentState.totalQuestions - 1,
                currentQuestionOrder: 0
            });

            return;

        }
        const deletedQuestionIds = [
            ...currentState.deletedQuestionIds,
            questionId
        ];

        state.setFormsEdit({
            ...currentState,
            questions: questions,
            deletedQuestionIds: deletedQuestionIds,
            totalQuestions: questions.length,
            currentQuestionOrder: 0
        });
    }

    const confirmAction = (
        message: string,
        acceptCallback: () => void ) => {
        confirmDialog({
          message,
          header: "Confirmação",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Sim",
          rejectLabel: "Não",
          accept: acceptCallback,
        });
      };

    const editQuestion = (questionId: string) => {
        setCurrentQuestionId(questionId);
        setEditQuestionsVisible(true);
    }

    const header = (
        <div style={{ 
            width: "100%", 
            display: "flex", 
            justifyContent: "space-between", 
            background: "inherit",
            padding: "0.25rem 0", 
            }}>
            <p>Perguntas:</p>
            <Button 
            type="button"
            icon="pi pi-plus"
            tooltip="Adicionar pergunta"
            style={{ width: "2.5rem", height: "2.5rem" }}
            onClick={() => {
                setCurrentQuestionId(null);
                setEditQuestionsVisible(true);
            }}
            />
        </div>
    );
    const orderdQuestions = state.formData.questions.sort((a, b) => a.order - b.order) ?? [];
    return (
        <div style={{ display: "flex", flexDirection: "column", flex: 1, height: "100%"}}>
            <DataTable
            reorderableRows
            scrollable
            scrollHeight="flex"
            onRowReorder={(e) => {
                const reorderdRows = e.value.map((question, index) => {
                    const updatedQuestion = question as FormQuestion;
                    updatedQuestion.order = index + 1;
                    return updatedQuestion;
                });
                state.setFormsEdit({questions: reorderdRows})
            }}
            pt={{header: {style: {background: "transparent", border: "none"}}}}
            header={header}
            key={state.formData.questions.length}
            ref={dt}
            value={orderdQuestions}
            dataKey="id"
            >
                <Column 
                field="label"
                header="Pergunta"
                />

                <Column 
                field="type"
                header="Tipo"
                />

                <Column 
                field="required"
                header="Obrigatória"
                body={(rowData) => rowData.required ? "Sim" : "Não"}
                />

                <Column 
                field="actions"
                header="Ações"
                body={(rowData) => (
                    <div>
                        <Button 
                        text
                        icon="pi pi-pencil"
                        onClick={() => editQuestion(rowData.id)}
                        />

                        <Button 
                        text
                        icon="pi pi-trash"
                        onClick={() => {
                            confirmAction(
                                `Deseja apagar a pregunta "${rowData.label}"`, 
                                () => deleteQuestion(rowData.id)
                            );
                        }}
                        />
                    </div>
                )}
                />
                <Column rowReorder style={{ width: "3rem" }} />
            </DataTable>
            <Dialog 
            visible={editQuestionVisible} 
            onHide={() => setEditQuestionsVisible(false)}
            style={{width: "35%"}}
            header={currentQuestionId === null ? "Adicionar Pergunta" : "Editar Pergunta"}
            >
            <ManageQuestion questionId={currentQuestionId} onClose={() => {setEditQuestionsVisible(false)}} />
            </Dialog>
        </div>
    );
}

export default ManageQuestionsGrid;